import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { AngularMaterialModule } from '../../../core/modules/angular-material/angular-material.module'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { LoginService } from '../../../core/services/login/login.service'
import { Router } from '@angular/router'
import { AuthService } from '../../../core/services/auth/auth.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { PermissionService } from '../../../core/services/permission/permission.service'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

@Component({
  imports: [AngularMaterialModule, ReactiveFormsModule, MatProgressSpinner],
  selector: 'login-form',
  standalone: true,
  styleUrl: './login-form.component.scss',
  templateUrl: './login-form.component.html',
  providers: [LoginService, AuthService, PermissionService],
})
export class LoginFormComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private permissionService: PermissionService,
    private router: Router,
    private snackbarCustomService: SnackbarCustomService,
  ) {}

  @Output() forgotPassword = new EventEmitter<void>()

  loginForm: FormGroup = new FormGroup({})
  rememberAccess = false
  loading = false
  typeList: { id: number; name: string }[] = [
    { id: 1, name: 'Consultor' },
    { id: 2, name: 'Administrador' },
    { id: 3, name: 'Gestor' },
  ]

  ngOnInit() {
    this.checkRemember()
    this.createForm()
  }

  createForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      // userType: [1, [Validators.required]],
    })
  }

  checkRemember() {
    const remember: string | null = localStorage.getItem('remember-access')
    if (remember) {
      this.rememberAccess = true
    } else {
      this.rememberAccess = false
    }
  }

  checkForm() {
    return this.checkEmail() && this.loginForm.get('password')?.value
    // return (
    //   this.checkEmail() &&
    //   this.loginForm.get('password')?.value &&
    //   this.loginForm.get('userType')?.value > 0
    // )
  }

  checkEmail() {
    const email = this.loginForm.get('email')?.value
    if (!email) {
      return false
    }
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    return emailPattern.test(email)
  }

  forgotPass() {
    this.forgotPassword.emit()
  }

  sendLogin(): void {
    const loginData = {
      email: this.loginForm.get('email')?.value,
      senha: this.loginForm.get('password')?.value,
    }
    this.loading = true

    this.loginService.loginSystem(loginData).subscribe({
      next: (response: any) => {
        if (response?.data?.token) {
          this.authService.saveToken(response.data.token)
          this.authService.saveInfo(response.data)
          this.getPermissions()
          // this.router.navigate(['/home'])
          // this.snackbarCustomService.success('Login realizado com sucesso!')
        } else {
          this.snackbarCustomService.error('Erro ao logar no sistema.')
        }
      },
      error: (error) => {
        let errorMessage = 'Ocorreu um erro ao realizar o login.'
        if (error.error) {
          const errorJson = error.error
          errorMessage = errorJson?.message || 'Erro desconhecido.'
        } else if (error.status === 0) {
          errorMessage = 'Falha de rede ou servidor não encontrado.'
        } else {
          errorMessage = `Erro desconhecido: ${error.message || error.statusText}`
        }
        this.snackbarCustomService.error(errorMessage)
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  getPermissions() {
    this.permissionService.permissionUserlogged().subscribe({
      next: (response: any) => {
        this.authService.savePermissions(response.data)
        this.router.navigate(['/home'])
        this.snackbarCustomService.success('Login realizado com sucesso!')
        // if (response?.data?.token) {
        //   this.authService.saveToken(response.data.token)
        //   this.getPermissions()
        //   this.router.navigate(['/home'])
        //   this.snackbarCustomService.success('Login realizado com sucesso!')
        // } else {
        //   this.snackbarCustomService.error('Erro ao logar no sistema.')
        // }
      },
      error: (error) => {
        let errorMessage = 'Ocorreu um erro ao realizar o login.'
        if (error.error) {
          const errorJson = error.error
          errorMessage = errorJson?.message || 'Erro desconhecido.'
        } else if (error.status === 0) {
          errorMessage = 'Falha de rede ou servidor não encontrado.'
        } else {
          errorMessage = `Erro desconhecido: ${error.message || error.statusText}`
        }
        this.snackbarCustomService.error(errorMessage)
      },
      complete: () => {},
    })
  }
}
